import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { AdminOrganizationsState } from './types';
import type { AdminOrganizationListItem } from './api';

const initialState: AdminOrganizationsState = {
  items: [],
  totalCount: 0,
  page: 1,
  pageSize: 20,
  search: '',
  tier: '',
  isLoading: false,
  error: null
};

export const slice = createSlice({
  name: 'adminOrganizations',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    getOrganizationsSuccess(
      state,
      action: PayloadAction<{ items: AdminOrganizationListItem[]; totalCount: number }>
    ) {
      state.isLoading = false;
      state.items = action.payload.items;
      state.totalCount = action.payload.totalCount;
    },
    hasError(state, action: PayloadAction<string | null>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
      state.page = 1;
    },
    setTier(state, action: PayloadAction<string>) {
      state.tier = action.payload;
      state.page = 1;
    },
    setPage(state, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    clearError(state) {
      state.error = null;
    }
  }
});

export default slice.reducer;
